module.exports = __webpack_public_path__ + "static/media/Roasted_Carrot.68d841f4.webp";